<template>
  <transition name="animation-opacity">
    <div class="popup" @click.self="close()" v-if="isOpen">
      <div class="popup__modal">
        <ButtonClose class="popup__close" @click="close()" />
        <PonModule />
      </div>
    </div>
  </transition>
</template>

<script setup>
  import { usePonPopup } from '@/Groups/Pon/private/imports/toggleDropdown';
  //-----------------------------------
  import ButtonClose from '@/Groups/Pon/private/ui/ButtonClose/ButtonClose.vue';
  import PonModule from '@/Groups/Pon/private/core/PonModule/PonModule.vue';
  //-----------------------------------
  const { close, isOpen } = usePonPopup();
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>